export default __webpack_public_path__ + "static/media/Version control-pana (1).45da622e.png";